export enum SiteTab {
  ACTIVE = 'sites',
  INACTIVE = 'inactive-sites',
}
